import React from "react";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP.js";
import Footer from "../../Includes/Layouts/VAQ_UB_4_3/Footer.js";
import FbViewPixel from "../../../Utility/FbViewPixel.js";
import "../../../assets/VAQ_UB_4_3_1_D/scss/VAQ_UB_4_3_1_D.scss";
import AccordSection from "../../Includes/Layouts/VAQ_UB_4_3/AccordSection.js";
import FormVAQ_UB_4_3_1_D from "../../Forms/FormVAQ_UB_4_3_1_D";

const VAQ_UB_4_3_1_D = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="VAQ_UB_4_3_1_D" />
      <FbViewPixel />
      <div className="VAQ_UB_4_3_1_D">
        <FormVAQ_UB_4_3_1_D />
        <AccordSection />
        <Footer />
      </div>
    </>
  );
};

export default VAQ_UB_4_3_1_D;
